import classNames from "classnames";
import { RichText } from "components/RichTextWidget";
import React, { useMemo } from "react";
import { useTabsState } from "shared/components/Tabs/Tabs.hooks";

import { serializeItem } from "../Content010.utils.js";
import styles from "./YearsView.module.scss";

export const YearsView = ({ items }) => {
  const { activeTab } = useTabsState();

  const filteredYears = useMemo(() => {
    return items.filter((item) => serializeItem(item) === activeTab);
  }, [activeTab, items]);

  return (
    <>
      {filteredYears.map((item) => (
        <React.Fragment key={item.id}>
          <div
            className={classNames(styles.years, {
              [styles["fade-in"]]: serializeItem(item) === activeTab,
            })}
          >
            <span>{item.yearFrom}</span>
            <span></span>
            <span>{item.yearTo}</span>
          </div>
          <div
            className={classNames(styles.description, {
              [styles["fade-in"]]: serializeItem(item) === activeTab,
            })}
          >
            <RichText value={item.description} />
          </div>
        </React.Fragment>
      ))}
    </>
  );
};

export default YearsView;
